/*
    With site data blocked, as in a payer page framed by a site whose visitor blocks third-party
    storage, merely reading window.localStorage throws. react-data-table-component reads it
    on every mount and _app's StoreBackUrl reads sessionStorage, both unguarded, and either
    takes the whole page down to the error screen. So swap in a memory-backed one before any
    of that runs. Imported first in _app.

    Its contents are gone after a reload, so anything relying on a value surviving one has to
    check isUsingStorageFallback. See utils/chunkReload.js.
*/
const createMemoryStorage = () => {
    const items = new Map();
    return {
        get length() { return items.size; },
        key: (index) => [...items.keys()][index] ?? null,
        getItem: (key) => (items.has(String(key)) ? items.get(String(key)) : null),
        setItem: (key, value) => { items.set(String(key), String(value)); },
        removeItem: (key) => { items.delete(String(key)); },
        clear: () => { items.clear(); },
    };
};

const isAvailable = (name) => {
    try {
        return !!window[name];
    } catch {
        return false;
    }
};

const fallbacks = new Set();

export const isUsingStorageFallback = (name) => fallbacks.has(name);

export const installStorageFallback = () => {
    if (typeof window === 'undefined') return;
    ['localStorage', 'sessionStorage'].forEach((name) => {
        if (!isAvailable(name)) {
            Object.defineProperty(window, name, {value: createMemoryStorage(), configurable: true});
            fallbacks.add(name);
        }
    });
};

installStorageFallback();
